import { FC } from 'react';
import styled from 'styled-components';
import { fontSize } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { theme } from '../../../theme';

const Wrapper = styled.div`
  ${fontSize};
  align-items: center;
  background-color: ${themeGet('colors.blacks[3]', 'rgba(0,0,0,.1)')};
  border: thin solid ${themeGet('colors.whites[4]', 'rgba(255,255,255,.2)')};
  border-radius: ${theme.space[5]}px;
  display: inline-flex;
  flex: none;
  font-size: ${theme.fontSize[0]};
  font-weight: 400;
  min-height: ${theme.space[5]}px;
  margin: ${theme.space[1]}px;
  padding: 0 ${theme.space[3]}px;
  word-break: break-word;
`;

const ChipText = styled.span`
  ${fontSize};
`;

export interface ChipProps {
  text: string | number;
}

/**
 * @render react
 * @name Chip component
 * @description Compact element that represent an input, attribute, or action.
 * @example
 * <Chip text="Name" />
 */

const Chip: FC<ChipProps> = ({ text, ...rest }) => (
  <Wrapper>
    <ChipText {...rest}>{text}</ChipText>
  </Wrapper>
);

export default Chip;
